import { useEffect } from "react";

export function useSeo(title, description) {
  useEffect(() => {
    if (title) document.title = `${title} | The Happy Bulldog Co.™`;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) { tag = document.createElement("meta"); tag.name = "description"; document.head.appendChild(tag); }
      tag.setAttribute("content", description);
    }
    return () => { document.title = "The Happy Bulldog Co.™ — A Chewie & Solo Adventure"; };
  }, [title, description]);
}
